/** Grouped lists for the Scam Alerts static resource page */

export const scamAlertsIntro = {
  kicker: 'Scam Alerts — Protect Yourself',
  paragraphs: [
    'Be aware: the following companies, platforms, and programs have been reported or warned against by regulators, law enforcement, or multiple credible sources for fraud, unlicensed trading, rug pulls, Ponzi-like behavior, or theft of investor funds.',
    'If you believe you have been affected by any of these, please submit a claim using our secure form.',
  ],
};

export const scamAlertsSections = [
  {
    title: 'Historic / Infamous Ponzi & Fraud Cases',
    items: [
      'BitConnect',
      'OneCoin',
      'PlusToken',
      'WoToken',
      'Mirror Trading International (MTI)',
      'USI-Tech',
      'PlexCoin',
      'Centra Tech',
      'BitClub Network',
      'DavorCoin',
      'Forsage',
      'GainBitcoin / GBMiners',
      'MiningMax',
      'Thodex',
      'My Big Coin',
      'PayCoin / PPCoin',
    ],
  },
  {
    title: 'Rug Pulls / Pump-and-Dump / Scam Tokens',
    items: [
      'Squid Game Token ($SQUID)',
      'Banana.Fund',
      'PonziCoin',
      'DIO token',
      'Bitcoiin',
    ],
  },
  {
    title: 'Fake / Rogue Platforms and Exchanges',
    items: [
      'Xuex.net',
      'Tradecage',
      'Swaper.io',
      'Pqtic.com',
      'Ultrax.io',
      'Pure-Exchange.com',
      'Strideex.com',
      'M.Slabu.com',
      'Cjb Crypto',
      'Crymatic.com',
      'Coin-team.com',
      'DLB Exchange',
      'Nestfincs.pro',
      'Rononlineedu.com',
      'Trade-dex.net',
      'Csecrypto.com',
      'HorizonPointe Financial Group (HPFG)',
      'Cryptoipo.net',
      '1 Broker',
      'Bitcarda',
      'CenturionBooster',
      'Diamond Reserve Club',
      'Envion AG',
      'Kromtech',
      'YieldNodes',
      'Bibox scams (fake support impersonations)',
      'Investment mining farm fraud sites',
      'Random airdrop scams',
      'Impersonated exchange “support” sites',
      'WoToken clone network schemes',
    ],
  },
  {
    title: 'Other Frequently Reported Scam Programs / Platforms',
    items: [
      'Nova Tech FX',
      'BitFunds',
      'Energise Trade',
      'B.E.Kxpro Foundation',
      'Cryptostarbot',
      'Paytrading',
      'WTC',
      'Greencorp Investments',
      'Payswitchub',
      'MT7 coin',
      'Bitfreds',
      'CoinEquityx',
      'Quest Option',
      'Tymetradepro',
      'Fieldia',
      'Equity',
      'IC-Crypto',
      'StoneBridgeVentures',
      'EZ Invest',
      'Wefinancial',
      'MGN Group',
      'Quantumstar',
      'Prime-CC',
      'Orcalnvestment',
      'BTrade CRG',
      'TradeVision CRG',
      'Purpl',
      'Trade365 CRG',
      'Helios Expert',
      'WilliamYoungs CRG',
      'Bulltrend',
      'NTC',
      'Markethaven',
      'Fintechreserve',
      'RevenueCenter',
      'Banxso',
      'FICRM 2022',
      'Jpmreview',
      'IIA+',
      'Crownmanagers',
      'FXAlta New CRG',
      'SigmaCapitals',
      'Gemini-Tangskt',
      'Torque',
      'Witlink',
      'Abeonacoin',
      'ABX Exchange',
      'Analyfx',
      'Andex trade',
      'Ancoin Exchange',
      'AstroFx',
      'BBIC',
      'Binarymate',
      'Binary Online',
      'Binary Tilt',
      'Bit Ocean',
      'Bit Pad',
    ],
  },
];
